import * as announcement from "./announcement";
import * as fetchAnnouncement from "./fetchAnnouncement";
import { initialState as announcementInitialState, AnnouncementRequestInfoState } from "./announcement";
import { initialState as fetchAnnouncementInitialState, FetchAnnouncementInfoState } from "./fetchAnnouncement";
import reduceReducers from "reduce-reducers";


export const Types: { [key: string]: any } = {
    ...announcement.Types,
    ...fetchAnnouncement.Types
};

export const Actions: { announcement: typeof announcement.Actions, fetchAnnouncement: typeof fetchAnnouncement.Actions } = {
    announcement: announcement.Actions,
    fetchAnnouncement: fetchAnnouncement.Actions
};

export const announcementRequestReducer = reduceReducers<AnnouncementRequestInfoState>(
    announcementInitialState,
    announcement.default as any
);

export const fetchAnnouncementRequestReducer = reduceReducers<FetchAnnouncementInfoState>(
    fetchAnnouncementInitialState,
    fetchAnnouncement.default as any
);

export default {
    announcement: announcementRequestReducer,
    fetchAnnouncement: fetchAnnouncementRequestReducer
};